import { ReactNode } from 'react';
import { ON_FARM_BILLING_CONSTANTS } from '../../constants/common';
import { OnFarmBillingPreview } from '../../types/interfaces/onFarmBillingOverride.interfaces';
import {
  formatOnFarmCents,
  formatOnFarmPlan,
  formatOnFarmValue,
  getOnFarmAccountStatus,
  getOnFarmStatusClass,
} from '../../pages/on-farm-billing-management/onFarmBillingManagement.utils';

type OnFarmBillingAccountInfoProps = {
  accountName?: string;
  preview?: OnFarmBillingPreview;
  children?: ReactNode;
};

const OnFarmBillingAccountInfo = ({ accountName, preview, children }: OnFarmBillingAccountInfoProps) => {
  const dueCents = preview?.onFarmOutstandingBalanceCents;
  const usingOnFarm = Boolean(preview?.isUsingOnFarm);
  const status = getOnFarmAccountStatus(preview?.isOnFarmBlocked);

  return (
    <article className="on-farm-account-summary">
      <div className="on-farm-account-summary__top">
        <h3>{accountName}</h3>
        {status && <span className={getOnFarmStatusClass(status)}>{status}</span>}
      </div>

      {usingOnFarm ? (
        <div className="on-farm-account-summary__metrics">
          <div className="metric">
            <span className="metric__label">{ON_FARM_BILLING_CONSTANTS.APPROVED_PLAN}</span>
            <span className="on-farm-tag">{formatOnFarmPlan(preview?.isCustomQuote)}</span>
          </div>
          <div className="metric">
            <span className="metric__label">{ON_FARM_BILLING_CONSTANTS.MONTHLY_FEE}</span>
            <span className="metric__value">{formatOnFarmCents(preview?.planMonthlyFeeCents)}</span>
          </div>
          <div className="metric">
            <span className="metric__label">{ON_FARM_BILLING_CONSTANTS.MAX_TANKS}</span>
            <span className="metric__value">{formatOnFarmValue(preview?.maxTanks)}</span>
          </div>
          <div className="metric">
            <span className="metric__label">{ON_FARM_BILLING_CONSTANTS.ON_FARM_DUE}</span>
            <span className={`metric__value${(dueCents ?? 0) > 0 ? ' is-due' : ''}`}>{formatOnFarmCents(dueCents)}</span>
          </div>
        </div>
      ) : (
        <p className="on-farm-account-summary__hint">{ON_FARM_BILLING_CONSTANTS.NOT_USING_HINT}</p>
      )}

      {children && <div className="on-farm-account-summary__actions">{children}</div>}
    </article>
  );
};

export default OnFarmBillingAccountInfo;
